import { normalizeServerUrl } from "../lib/serverUrl.js";

const KEY = "pf.serverUrl";
let memory: string | undefined;

/** The API address the desktop app talks to. Not secret, so it lives in localStorage. */
export function storedServerUrl(): string | undefined {
  try {
    const raw = window.localStorage.getItem(KEY);
    return (raw === null ? undefined : normalizeServerUrl(raw)) ?? memory;
  } catch {
    return memory;
  }
}

/** Saves a validated address. Returns the normalized value, or undefined when it was rejected. */
export function saveServerUrl(raw: string): string | undefined {
  const normalized = normalizeServerUrl(raw);
  if (normalized === undefined) {
    return undefined;
  }
  memory = normalized;
  try {
    window.localStorage.setItem(KEY, normalized);
  } catch {
    // Private storage unavailable: the address only applies until the app closes.
  }
  return normalized;
}
